import React from "react";
import ListItem from "@mui/material/ListItem";
import { useGame, useUpdateGameV2 } from "@seabrookstudios/pitch2table";
import CircularProgress from "@mui/material/CircularProgress";
import { EditableListItemText } from "../core/EditableListItemText";
import { Automatic } from "../games/DesignerBlock";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 */
export const GameVisibilityCreditsControl = ({ gameId }) => {
  const updateGame = useUpdateGameV2(gameId);
  const { data: game } = useGame(gameId);

  /**
   * @param {string} customAuthors
   */
  const updateCustomAuthor = async (customAuthors) => {
    await updateGame.mutateAsync({
      customAuthors,
      sizzle: undefined,
      bgg: undefined,
      personalGoal: undefined,
      referenceId: undefined,
      tags: undefined,
      feedbackEnabled: undefined,
      gameType: undefined,
    });
  };

  if (!game) {
    return <CircularProgress />;
  }

  return (
    <ListItem>
      <EditableListItemText
        primary={game.customAuthors ? "Displayed Credits (custom)" : "Displayed Credits (automatic)"}
        secondary={game.customAuthors || ""}
        formatter={(v) => (game.customAuthors ? v : <Automatic designers={game.designers} />)}
        onSave={updateCustomAuthor}
        helperText="Shown on public page and overrides the automated credits. Use this when one of the designers is not on pitch2table."
        isBusy={updateGame.isPending}
      />
    </ListItem>
  );
};
